<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :destroy-on-close="true" :close-on-click-modal="false">
        <Language :add="add" v-model="form.lang" @change="handleLangChange" style="margin-top: -20px"></Language>
        <el-form label-width="110px" :model="form" ref="form" :rules="rules">
            <el-form-item label="排序" prop="sort">
                <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="筛选项名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入筛选项名称"></el-input>
            </el-form-item>
            <el-form-item label="是否显示" prop="status">
                <el-switch v-model="form.status"> </el-switch>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { add, edit, detail } from "@/api/product/filter";
import { getUuid } from "@/jslibs/utils";
import Language from "@/components/Language";
export default {
    components: { Language },
    data() {
        return {
            title: "添加筛选项",
            form: {
                sort: "",
                name: "",
                status: true,
                cuuid: "",
                lang: "zh",
            },
            visible: false,
            rules: {
                sort: [{ required: true, message: "请输入排序" }],
                name: [{ required: true, message: "请输入筛选项名称" }],
            },
            cuuid: "",
            add: true,
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.form = row ? { ...row } : {};
            if (row) {
                this.add = false;
                this.title = "编辑筛选项";
                this.cuuid = row.cuuid;
                this.form.status = row.status == 1;
            } else {
                this.add = true;
                this.title = "添加筛选项";
                this.form.cuuid = getUuid();
                this.form.lang = "zh";
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleLangChange(lang) {
            this.getDetail(lang);
        },
        getDetail(lang) {
            detail({ cuuid: this.form.cuuid, lang }).then(({ code, result, error }) => {
                if (code == 200) {
                    this.form = result ? { ...result, status: result.status == 1 } : { cuuid: this.form.cuuid, lang };
                    this.cuuid = result ? result.cuuid : "";
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    name: this.form.name,
                    sort: this.form.sort,
                    status: this.form.status ? "1" : "2",
                    cuuid: this.form.cuuid,
                    lang: this.form.lang,
                };
                if (!this.form.uuid) {
                    add(params).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$emit("update");
							this.visible = false;
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    if (this.cuuid) {
                        params.uuid = this.form.uuid;
                        edit(params).then(({ code, error }) => {
                            if (code == 200) {
                                this.$message.success("编辑成功");
                                this.$emit("update");
								this.visible = false;
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code == 200) {
                                this.$message.success("添加成功");
                                this.$emit("update");
								this.visible = false;
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                }
            });
        },
    },
};
</script>

<style></style>
